import _ from 'lodash'
import store from '@/store'

function translate(key, blockId) {
  var value = _.get(store.getters.clientModel, ['blocks', blockId, key])
  if(_.isUndefined(value)) {
    return `[${key}]`
  }
  return value
}

function formatPrice(price) {
  const currency = store.getters.clientModel.currency
  const region = store.getters.clientModel.region
  if(!region || !currency) {
    return price
  }
  return new Intl.NumberFormat(region, { style: 'currency', currency, maximumFractionDigits: 2, minimumFractionDigits: 2 }).format(price)
}

function formatPriceWithoutCurrency(price) {
  const currency = store.getters.clientModel.currency
  const region = store.getters.clientModel.region
  if(!region || !currency) {
    return price
  }
  return new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2, useGrouping: false }).format(price)
}

export { translate, formatPrice, formatPriceWithoutCurrency }
